import { render } from "./Note.vue?vue&type=template&id=3912f878&scoped=true"
import script from "./Note.vue?vue&type=script&lang=js"
export * from "./Note.vue?vue&type=script&lang=js"

import "./Note.vue?vue&type=style&index=0&id=3912f878&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3912f878"

export default script